import React from "react";
import { Redirect, RedirectProps, RouteComponentProps, withRouter } from "react-router";

import { History } from "history";

import * as Api from "../Api";
import { IAuthProps } from "./AuthContext";
import withAuth from "./withAuth";

interface IUnauthenticatedRedirectProps extends IAuthProps, RouteComponentProps<any>, RedirectProps {
    passwordTo: History.LocationDescriptor;
}

interface IUnauthenticatedRedirectState {
    forceLogin: boolean;
}

class UnauthenticatedRedirect extends React.Component<IUnauthenticatedRedirectProps, IUnauthenticatedRedirectState> {
    constructor(props: Readonly<IUnauthenticatedRedirectProps>) {
        super(props);

        this.state = {
            forceLogin: false,
        };

        this.handleApiEvent = this.handleApiEvent.bind(this);
    }

    public componentDidMount() {
        Api.addApiEventListener(this.handleApiEvent)
    }

    public componentWillUnmount() {
        Api.removeApiEventListener(this.handleApiEvent)
    }

    public componentDidUpdate(prevProps: Readonly<IUnauthenticatedRedirectProps>) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setState({
                forceLogin: false
            });
        }
    }

    public render() {
        if ((this.state.forceLogin || !this.props.authContext.isAuthenticated) && this.props.location.pathname !== this.props.to) {
            const { to, ...props } = this.props;
            let newTo: History.LocationDescriptor<any>;
            if (typeof to === "string") {
                newTo = {
                    pathname: to
                }
            }
            else {
                newTo = to;
            }

            if (!newTo.state) {
                newTo.state = {};
            }

            if (this.props.location.pathname !== "/changepassword") {
                newTo.state.referer = this.props.location;
            }

            return <Redirect {...props} to={newTo} />
        }

        if (this.props.authContext.forcePasswordChange && this.props.location.pathname !== this.props.passwordTo) {
            const { to, passwordTo, ...props } = this.props;

            return <Redirect {...props} to={passwordTo} />
        }

        return this.props.children;
    }

    private handleApiEvent(eventType: Api.ApiEvents) {
        switch (eventType) {
            case "no_auth":
                // Show login page if user's become unauthenticated
                if (this.props.authContext.isAuthenticated) {
                    this.setState({
                        forceLogin: true
                    });
                }
                break;
            default:
                break;
        }
    }
}

export default withAuth(withRouter(UnauthenticatedRedirect));
